import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './KertasKerjaSanding.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'
import { inject, observer } from 'mobx-react'
import {
  Caption,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableContainer
} from "@react-md/table";



var _baseId = "mod-table-sanding-aset[-3"

const KertasKerjaSandingTable = ({
  className       = '',
  showCommandbar  = true,
  history,
  match,
  sipStore,
  navigationStore
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})
  const [sum, setSum] = useState({
    koreksiFiskal: 0,
    penyusutanFiskal: 0,
    penyusutanKomersial: 0
  })

  useEffect(() => {
    async function initData() {
      const res = await service.http.get(service.path+"/sum", {'periodeFiskalId.equals': sipStore.periodeId, 'akunId.equals': match.params.id})
      setSum(res.data)
    }
    initData()
  }, ['match.params.id'])

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title='Kertas Kerja Sanding'
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Tanggal Perolehan',
          searchable: true,
          key: 'tanggalPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tanggalPerolehan)
        },
        {
          label: 'Nomor Aktiva Tetap',
          searchable: true,
          key: 'nomorAktivaTetap',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nomor)
        },
        {
          label: 'Tanggal Transaksi',
          searchable: true,
          key: 'tanggalTransaksi',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.transaksiTanggal)
        },
        {
          label: 'Harga Perolehan',
          searchable: true,
          key: 'hargaPerolehan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.hargaTotalPerolehan))
        }

      ]}
      actions={[
        // new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/penyusutan-periode-aset/baru'), true)
      ]}
      itemActions={[
        // s
      ]}
      onFetchData={ async query => {
        if(!query) query = {}
        if(sipStore.periodeId) {
          query['akunId.equals'] = sipStore.periodeId
        }
        query['akunAktivaId.equals'] = match.params.id

        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
      tableFooter={<Table style={{width:'100%'}} >
      <TableBody fullWidth>
        <TableRow>
          <TableCell>Harga Total Perolehan</TableCell>
          <TableCell style={{textAlign: 'right'}}>{Utils.numberFormat(sum.hargaTotalPerolehan)}</TableCell>
        </TableRow>
      </TableBody>
    </Table>}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default inject('sipStore', 'navigationStore')(observer(KertasKerjaSandingTable))
